import { render } from "./BenefitSuccessModal.vue?vue&type=template&id=21a34570&scoped=true"
import script from "./BenefitSuccessModal.vue?vue&type=script&lang=js"
export * from "./BenefitSuccessModal.vue?vue&type=script&lang=js"

import "./BenefitSuccessModal.vue?vue&type=style&index=0&id=21a34570&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a34570"]])

export default __exports__